export default "__VITE_ASSET__209b698a__"